import { render, staticRenderFns } from "./Dance.vue?vue&type=template&id=c409c824&scoped=true&"
import script from "./Dance.vue?vue&type=script&lang=js&"
export * from "./Dance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409c824",
  null
  
)

export default component.exports